import { boundApiRequest } from '@/restapi/restapi.base.js';


const doRequest = boundApiRequest('/api/news/subscription/');


/**
 * Получение конфигурации подписки
 */
export async function getSubscriptionConfig() {
    const { result } = await doRequest('config/get', {}, {});
    return result;
}

/**
 * Сохранение конфигурации подписки
 */
export async function saveSubscriptionConfig(data) {
    const { result } = await doRequest('config/change', data, {
        blocking: true,
    });
    return result;
}

export async function subscribeProduct(data) {
    const { result } = await doRequest('product/change', data);
    return result;
}

export async function search(reqt) {
    const { result } = await doRequest('search', reqt, {});
    return result;
}
